module.exports = __webpack_public_path__ + "static/media/swingSideFrame.aff5c78d.png";